.google-button {
  position: fixed;
  display: flex;
  top: 130px;
  right: 38px;
  padding: 12px;
  background: $background-color-primary;
  box-shadow: 0 2px 16px rgb(44 44 44 / 24%);
  border-radius: 4px;
  z-index: 105;
  cursor: pointer;
  align-items: center;
  opacity: 0;
  animation: fade-in 75ms ease-in forwards;
  transition: top 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    cursor: pointer;
  }

  svg {
    .google-icon {
      opacity: 1;
      transition: all 0.15s ease-in;
    }

    .load-icon {
      opacity: 0;
      transition: all 0.15s ease-in;
    }
  }

  .google-button__text {
    display: flex;
    margin-left: 18px;
    font-family: Graphik, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.005em;
    color: $color-neutral-black;
    user-select: none;
  }

  &.is-hidden {
    display: none !important;
  }

  @include below-desktop {
    display: none;
  }
}

.navbar-hidden {
  .google-button {
    top: 14px;
  }
}

.navbar-fixed {
  .google-button {
    top: 92px;
  }

  &.search-visible {
    .google-button {
      top: 136px;
    }
  }
}

.search-visible {
  .google-button {
    top: 186px;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
